import state from "./interactionState";
import mutations from "./interactionMutations";
import getters from "./interactionGetters";
import actions from "./interactionActions";

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
};
